export default [
	{
		abbreviation: 'AD',
		dialCode: '+376',
		flag: '🇦🇩',
		fullName: 'Andorra',
		label: '🇦🇩 +376',
		value: 'AD',
	},
	{
		abbreviation: 'AE',
		dialCode: '+971',
		flag: '🇦🇪',
		fullName: 'United Arab Emirates',
		label: '🇦🇪 +971',
		value: 'AE',
	},
	{
		abbreviation: 'AF',
		dialCode: '+93',
		flag: '🇦🇫',
		fullName: 'Afghanistan',
		label: '🇦🇫 +93',
		value: 'AF',
	},
	{
		abbreviation: 'AG',
		dialCode: '+1268',
		flag: '🇦🇬',
		fullName: 'Antigua and Barbuda',
		label: '🇦🇬 +1268',
		value: 'AG',
	},
	{
		abbreviation: 'AI',
		dialCode: '+1264',
		flag: '🇦🇮',
		fullName: 'Anguilla',
		label: '🇦🇮 +1264',
		value: 'AI',
	},
	{
		abbreviation: 'AL',
		dialCode: '+355',
		flag: '🇦🇱',
		fullName: 'Albania',
		label: '🇦🇱 +355',
		value: 'AL',
	},
	{
		abbreviation: 'AM',
		dialCode: '+374',
		flag: '🇦🇲',
		fullName: 'Armenia',
		label: '🇦🇲 +374',
		value: 'AM',
	},
	{
		abbreviation: 'AN',
		dialCode: '+599',
		flag: '',
		fullName: 'Netherlands Antilles',
		label: ' +599',
		value: 'AN',
	},
	{
		abbreviation: 'AO',
		dialCode: '+244',
		flag: '🇦🇴',
		fullName: 'Angola',
		label: '🇦🇴 +244',
		value: 'AO',
	},
	{
		abbreviation: 'AQ',
		dialCode: '+672',
		flag: '🇦🇶',
		fullName: 'Antarctica',
		label: '🇦🇶 +672',
		value: 'AQ',
	},
	{
		abbreviation: 'AR',
		dialCode: '+54',
		flag: '🇦🇷',
		fullName: 'Argentina',
		label: '🇦🇷 +54',
		value: 'AR',
	},
	{
		abbreviation: 'AS',
		dialCode: '+1684',
		flag: '🇦🇸',
		fullName: 'American Samoa',
		label: '🇦🇸 +1684',
		value: 'AS',
	},
	{
		abbreviation: 'AT',
		dialCode: '+43',
		flag: '🇦🇹',
		fullName: 'Austria',
		label: '🇦🇹 +43',
		value: 'AT',
	},
	{
		abbreviation: 'AU',
		dialCode: '+61',
		flag: '🇦🇺',
		fullName: 'Australia',
		label: '🇦🇺 +61',
		value: 'AU',
	},
	{
		abbreviation: 'AW',
		dialCode: '+297',
		flag: '🇦🇼',
		fullName: 'Aruba',
		label: '🇦🇼 +297',
		value: 'AW',
	},
	{
		abbreviation: 'AX',
		dialCode: '+358',
		flag: '🇦🇽',
		fullName: 'Åland Islands',
		label: '🇦🇽 +358',
		value: 'AX',
	},
	{
		abbreviation: 'AZ',
		dialCode: '+994',
		flag: '🇦🇿',
		fullName: 'Azerbaijan',
		label: '🇦🇿 +994',
		value: 'AZ',
	},
	{
		abbreviation: 'BA',
		dialCode: '+387',
		flag: '🇧🇦',
		fullName: 'Bosnia and Herzegovina',
		label: '🇧🇦 +387',
		value: 'BA',
	},
	{
		abbreviation: 'BB',
		dialCode: '+1246',
		flag: '🇧🇧',
		fullName: 'Barbados',
		label: '🇧🇧 +1246',
		value: 'BB',
	},
	{
		abbreviation: 'BD',
		dialCode: '+880',
		flag: '🇧🇩',
		fullName: 'Bangladesh',
		label: '🇧🇩 +880',
		value: 'BD',
	},
	{
		abbreviation: 'BE',
		dialCode: '+32',
		flag: '🇧🇪',
		fullName: 'Belgium',
		label: '🇧🇪 +32',
		value: 'BE',
	},
	{
		abbreviation: 'BF',
		dialCode: '+226',
		flag: '🇧🇫',
		fullName: 'Burkina Faso',
		label: '🇧🇫 +226',
		value: 'BF',
	},
	{
		abbreviation: 'BG',
		dialCode: '+359',
		flag: '🇧🇬',
		fullName: 'Bulgaria',
		label: '🇧🇬 +359',
		value: 'BG',
	},
	{
		abbreviation: 'BH',
		dialCode: '+973',
		flag: '🇧🇭',
		fullName: 'Bahrain',
		label: '🇧🇭 +973',
		value: 'BH',
	},
	{
		abbreviation: 'BI',
		dialCode: '+257',
		flag: '🇧🇮',
		fullName: 'Burundi',
		label: '🇧🇮 +257',
		value: 'BI',
	},
	{
		abbreviation: 'BJ',
		dialCode: '+229',
		flag: '🇧🇯',
		fullName: 'Benin',
		label: '🇧🇯 +229',
		value: 'BJ',
	},
	{
		abbreviation: 'BL',
		dialCode: '+590',
		flag: '🇧🇱',
		fullName: 'Saint Barthelemy',
		label: '🇧🇱 +590',
		value: 'BL',
	},
	{
		abbreviation: 'BM',
		dialCode: '+1441',
		flag: '🇧🇲',
		fullName: 'Bermuda',
		label: '🇧🇲 +1441',
		value: 'BM',
	},
	{
		abbreviation: 'BN',
		dialCode: '+673',
		flag: '🇧🇳',
		fullName: 'Brunei Darussalam',
		label: '🇧🇳 +673',
		value: 'BN',
	},
	{
		abbreviation: 'BO',
		dialCode: '+591',
		flag: '🇧🇴',
		fullName: 'Bolivia, Plurinational State of bolivia',
		label: '🇧🇴 +591',
		value: 'BO',
	},
	{
		abbreviation: 'BR',
		dialCode: '+55',
		flag: '🇧🇷',
		fullName: 'Brazil',
		label: '🇧🇷 +55',
		value: 'BR',
	},
	{
		abbreviation: 'BS',
		dialCode: '+1242',
		flag: '🇧🇸',
		fullName: 'Bahamas',
		label: '🇧🇸 +1242',
		value: 'BS',
	},
	{
		abbreviation: 'BT',
		dialCode: '+975',
		flag: '🇧🇹',
		fullName: 'Bhutan',
		label: '🇧🇹 +975',
		value: 'BT',
	},
	{
		abbreviation: 'BV',
		dialCode: '+47',
		flag: '🇧🇻',
		fullName: 'Bouvet Island',
		label: '🇧🇻 +47',
		value: 'BV',
	},
	{
		abbreviation: 'BW',
		dialCode: '+267',
		flag: '🇧🇼',
		fullName: 'Botswana',
		label: '🇧🇼 +267',
		value: 'BW',
	},
	{
		abbreviation: 'BY',
		dialCode: '+375',
		flag: '🇧🇾',
		fullName: 'Belarus',
		label: '🇧🇾 +375',
		value: 'BY',
	},
	{
		abbreviation: 'BZ',
		dialCode: '+501',
		flag: '🇧🇿',
		fullName: 'Belize',
		label: '🇧🇿 +501',
		value: 'BZ',
	},
	{
		abbreviation: 'CA',
		dialCode: '+1',
		flag: '🇨🇦',
		fullName: 'Canada',
		label: '🇨🇦 +1',
		value: 'CA',
	},
	{
		abbreviation: 'CC',
		dialCode: '+61',
		flag: '🇨🇨',
		fullName: 'Cocos (Keeling) Islands',
		label: '🇨🇨 +61',
		value: 'CC',
	},
	{
		abbreviation: 'CD',
		dialCode: '+243',
		flag: '🇨🇩',
		fullName: 'Congo, The Democratic Republic of the Congo',
		label: '🇨🇩 +243',
		value: 'CD',
	},
	{
		abbreviation: 'CF',
		dialCode: '+236',
		flag: '🇨🇫',
		fullName: 'Central African Republic',
		label: '🇨🇫 +236',
		value: 'CF',
	},
	{
		abbreviation: 'CG',
		dialCode: '+242',
		flag: '🇨🇬',
		fullName: 'Congo',
		label: '🇨🇬 +242',
		value: 'CG',
	},
	{
		abbreviation: 'CH',
		dialCode: '+41',
		flag: '🇨🇭',
		fullName: 'Switzerland',
		label: '🇨🇭 +41',
		value: 'CH',
	},
	{
		abbreviation: 'CI',
		dialCode: '+225',
		flag: '🇨🇮',
		fullName: "Cote d'Ivoire",
		label: '🇨🇮 +225',
		value: 'CI',
	},
	{
		abbreviation: 'CK',
		dialCode: '+682',
		flag: '🇨🇰',
		fullName: 'Cook Islands',
		label: '🇨🇰 +682',
		value: 'CK',
	},
	{
		abbreviation: 'CL',
		dialCode: '+56',
		flag: '🇨🇱',
		fullName: 'Chile',
		label: '🇨🇱 +56',
		value: 'CL',
	},
	{
		abbreviation: 'CM',
		dialCode: '+237',
		flag: '🇨🇲',
		fullName: 'Cameroon',
		label: '🇨🇲 +237',
		value: 'CM',
	},
	{
		abbreviation: 'CN',
		dialCode: '+86',
		flag: '🇨🇳',
		fullName: 'China',
		label: '🇨🇳 +86',
		value: 'CN',
	},
	{
		abbreviation: 'CO',
		dialCode: '+57',
		flag: '🇨🇴',
		fullName: 'Colombia',
		label: '🇨🇴 +57',
		value: 'CO',
	},
	{
		abbreviation: 'CR',
		dialCode: '+506',
		flag: '🇨🇷',
		fullName: 'Costa Rica',
		label: '🇨🇷 +506',
		value: 'CR',
	},
	{
		abbreviation: 'CU',
		dialCode: '+53',
		flag: '🇨🇺',
		fullName: 'Cuba',
		label: '🇨🇺 +53',
		value: 'CU',
	},
	{
		abbreviation: 'CV',
		dialCode: '+238',
		flag: '🇨🇻',
		fullName: 'Cape Verde',
		label: '🇨🇻 +238',
		value: 'CV',
	},
	{
		abbreviation: 'CX',
		dialCode: '+61',
		flag: '🇨🇽',
		fullName: 'Christmas Island',
		label: '🇨🇽 +61',
		value: 'CX',
	},
	{
		abbreviation: 'CY',
		dialCode: '+357',
		flag: '🇨🇾',
		fullName: 'Cyprus',
		label: '🇨🇾 +357',
		value: 'CY',
	},
	{
		abbreviation: 'CZ',
		dialCode: '+420',
		flag: '🇨🇿',
		fullName: 'Czech Republic',
		label: '🇨🇿 +420',
		value: 'CZ',
	},
	{
		abbreviation: 'DE',
		dialCode: '+49',
		flag: '🇩🇪',
		fullName: 'Germany',
		label: '🇩🇪 +49',
		value: 'DE',
	},
	{
		abbreviation: 'DJ',
		dialCode: '+253',
		flag: '🇩🇯',
		fullName: 'Djibouti',
		label: '🇩🇯 +253',
		value: 'DJ',
	},
	{
		abbreviation: 'DK',
		dialCode: '+45',
		flag: '🇩🇰',
		fullName: 'Denmark',
		label: '🇩🇰 +45',
		value: 'DK',
	},
	{
		abbreviation: 'DM',
		dialCode: '+1767',
		flag: '🇩🇲',
		fullName: 'Dominica',
		label: '🇩🇲 +1767',
		value: 'DM',
	},
	{
		abbreviation: 'DO',
		dialCode: '+1849',
		flag: '🇩🇴',
		fullName: 'Dominican Republic',
		label: '🇩🇴 +1849',
		value: 'DO',
	},
	{
		abbreviation: 'DZ',
		dialCode: '+213',
		flag: '🇩🇿',
		fullName: 'Algeria',
		label: '🇩🇿 +213',
		value: 'DZ',
	},
	{
		abbreviation: 'EC',
		dialCode: '+593',
		flag: '🇪🇨',
		fullName: 'Ecuador',
		label: '🇪🇨 +593',
		value: 'EC',
	},
	{
		abbreviation: 'EE',
		dialCode: '+372',
		flag: '🇪🇪',
		fullName: 'Estonia',
		label: '🇪🇪 +372',
		value: 'EE',
	},
	{
		abbreviation: 'EG',
		dialCode: '+20',
		flag: '🇪🇬',
		fullName: 'Egypt',
		label: '🇪🇬 +20',
		value: 'EG',
	},
	{
		abbreviation: 'ER',
		dialCode: '+291',
		flag: '🇪🇷',
		fullName: 'Eritrea',
		label: '🇪🇷 +291',
		value: 'ER',
	},
	{
		abbreviation: 'ES',
		dialCode: '+34',
		flag: '🇪🇸',
		fullName: 'Spain',
		label: '🇪🇸 +34',
		value: 'ES',
	},
	{
		abbreviation: 'ET',
		dialCode: '+251',
		flag: '🇪🇹',
		fullName: 'Ethiopia',
		label: '🇪🇹 +251',
		value: 'ET',
	},
	{
		abbreviation: 'FI',
		dialCode: '+358',
		flag: '🇫🇮',
		fullName: 'Finland',
		label: '🇫🇮 +358',
		value: 'FI',
	},
	{
		abbreviation: 'FJ',
		dialCode: '+679',
		flag: '🇫🇯',
		fullName: 'Fiji',
		label: '🇫🇯 +679',
		value: 'FJ',
	},
	{
		abbreviation: 'FK',
		dialCode: '+500',
		flag: '🇫🇰',
		fullName: 'Falkland Islands (Malvinas)',
		label: '🇫🇰 +500',
		value: 'FK',
	},
	{
		abbreviation: 'FM',
		dialCode: '+691',
		flag: '🇫🇲',
		fullName: 'Micronesia, Federated States of Micronesia',
		label: '🇫🇲 +691',
		value: 'FM',
	},
	{
		abbreviation: 'FO',
		dialCode: '+298',
		flag: '🇫🇴',
		fullName: 'Faroe Islands',
		label: '🇫🇴 +298',
		value: 'FO',
	},
	{
		abbreviation: 'FR',
		dialCode: '+33',
		flag: '🇫🇷',
		fullName: 'France',
		label: '🇫🇷 +33',
		value: 'FR',
	},
	{
		abbreviation: 'GA',
		dialCode: '+241',
		flag: '🇬🇦',
		fullName: 'Gabon',
		label: '🇬🇦 +241',
		value: 'GA',
	},
	{
		abbreviation: 'GB',
		dialCode: '+44',
		flag: '🇬🇧',
		fullName: 'United Kingdom',
		label: '🇬🇧 +44',
		value: 'GB',
	},
	{
		abbreviation: 'GD',
		dialCode: '+1473',
		flag: '🇬🇩',
		fullName: 'Grenada',
		label: '🇬🇩 +1473',
		value: 'GD',
	},
	{
		abbreviation: 'GE',
		dialCode: '+995',
		flag: '🇬🇪',
		fullName: 'Georgia',
		label: '🇬🇪 +995',
		value: 'GE',
	},
	{
		abbreviation: 'GF',
		dialCode: '+594',
		flag: '🇬🇫',
		fullName: 'French Guiana',
		label: '🇬🇫 +594',
		value: 'GF',
	},
	{
		abbreviation: 'GG',
		dialCode: '+44',
		flag: '🇬🇬',
		fullName: 'Guernsey',
		label: '🇬🇬 +44',
		value: 'GG',
	},
	{
		abbreviation: 'GH',
		dialCode: '+233',
		flag: '🇬🇭',
		fullName: 'Ghana',
		label: '🇬🇭 +233',
		value: 'GH',
	},
	{
		abbreviation: 'GI',
		dialCode: '+350',
		flag: '🇬🇮',
		fullName: 'Gibraltar',
		label: '🇬🇮 +350',
		value: 'GI',
	},
	{
		abbreviation: 'GL',
		dialCode: '+299',
		flag: '🇬🇱',
		fullName: 'Greenland',
		label: '🇬🇱 +299',
		value: 'GL',
	},
	{
		abbreviation: 'GM',
		dialCode: '+220',
		flag: '🇬🇲',
		fullName: 'Gambia',
		label: '🇬🇲 +220',
		value: 'GM',
	},
	{
		abbreviation: 'GN',
		dialCode: '+224',
		flag: '🇬🇳',
		fullName: 'Guinea',
		label: '🇬🇳 +224',
		value: 'GN',
	},
	{
		abbreviation: 'GP',
		dialCode: '+590',
		flag: '🇬🇵',
		fullName: 'Guadeloupe',
		label: '🇬🇵 +590',
		value: 'GP',
	},
	{
		abbreviation: 'GQ',
		dialCode: '+240',
		flag: '🇬🇶',
		fullName: 'Equatorial Guinea',
		label: '🇬🇶 +240',
		value: 'GQ',
	},
	{
		abbreviation: 'GR',
		dialCode: '+30',
		flag: '🇬🇷',
		fullName: 'Greece',
		label: '🇬🇷 +30',
		value: 'GR',
	},
	{
		abbreviation: 'GS',
		dialCode: '+500',
		flag: '🇬🇸',
		fullName: 'South Georgia and the South Sandwich Islands',
		label: '🇬🇸 +500',
		value: 'GS',
	},
	{
		abbreviation: 'GT',
		dialCode: '+502',
		flag: '🇬🇹',
		fullName: 'Guatemala',
		label: '🇬🇹 +502',
		value: 'GT',
	},
	{
		abbreviation: 'GU',
		dialCode: '+1671',
		flag: '🇬🇺',
		fullName: 'Guam',
		label: '🇬🇺 +1671',
		value: 'GU',
	},
	{
		abbreviation: 'GW',
		dialCode: '+245',
		flag: '🇬🇼',
		fullName: 'Guinea-Bissau',
		label: '🇬🇼 +245',
		value: 'GW',
	},
	{
		abbreviation: 'GY',
		dialCode: '+592',
		flag: '🇬🇾',
		fullName: 'Guyana',
		label: '🇬🇾 +592',
		value: 'GY',
	},
	{
		abbreviation: 'HK',
		dialCode: '+852',
		flag: '🇭🇰',
		fullName: 'Hong Kong',
		label: '🇭🇰 +852',
		value: 'HK',
	},
	{
		abbreviation: 'HM',
		dialCode: '+672',
		flag: '🇭🇲',
		fullName: 'Heard Island and Mcdonald Islands',
		label: '🇭🇲 +672',
		value: 'HM',
	},
	{
		abbreviation: 'HN',
		dialCode: '+504',
		flag: '🇭🇳',
		fullName: 'Honduras',
		label: '🇭🇳 +504',
		value: 'HN',
	},
	{
		abbreviation: 'HR',
		dialCode: '+385',
		flag: '🇭🇷',
		fullName: 'Croatia',
		label: '🇭🇷 +385',
		value: 'HR',
	},
	{
		abbreviation: 'HT',
		dialCode: '+509',
		flag: '🇭🇹',
		fullName: 'Haiti',
		label: '🇭🇹 +509',
		value: 'HT',
	},
	{
		abbreviation: 'HU',
		dialCode: '+36',
		flag: '🇭🇺',
		fullName: 'Hungary',
		label: '🇭🇺 +36',
		value: 'HU',
	},
	{
		abbreviation: 'ID',
		dialCode: '+62',
		flag: '🇮🇩',
		fullName: 'Indonesia',
		label: '🇮🇩 +62',
		value: 'ID',
	},
	{
		abbreviation: 'IE',
		dialCode: '+353',
		flag: '🇮🇪',
		fullName: 'Ireland',
		label: '🇮🇪 +353',
		value: 'IE',
	},
	{
		abbreviation: 'IL',
		dialCode: '+972',
		flag: '🇮🇱',
		fullName: 'Israel',
		label: '🇮🇱 +972',
		value: 'IL',
	},
	{
		abbreviation: 'IM',
		dialCode: '+44',
		flag: '🇮🇲',
		fullName: 'Isle of Man',
		label: '🇮🇲 +44',
		value: 'IM',
	},
	{
		abbreviation: 'IN',
		dialCode: '+91',
		flag: '🇮🇳',
		fullName: 'India',
		label: '🇮🇳 +91',
		value: 'IN',
	},
	{
		abbreviation: 'IO',
		dialCode: '+246',
		flag: '🇮🇴',
		fullName: 'British Indian Ocean Territory',
		label: '🇮🇴 +246',
		value: 'IO',
	},
	{
		abbreviation: 'IQ',
		dialCode: '+964',
		flag: '🇮🇶',
		fullName: 'Iraq',
		label: '🇮🇶 +964',
		value: 'IQ',
	},
	{
		abbreviation: 'IR',
		dialCode: '+98',
		flag: '🇮🇷',
		fullName: 'Iran, Islamic Republic of Persian Gulf',
		label: '🇮🇷 +98',
		value: 'IR',
	},
	{
		abbreviation: 'IS',
		dialCode: '+354',
		flag: '🇮🇸',
		fullName: 'Iceland',
		label: '🇮🇸 +354',
		value: 'IS',
	},
	{
		abbreviation: 'IT',
		dialCode: '+39',
		flag: '🇮🇹',
		fullName: 'Italy',
		label: '🇮🇹 +39',
		value: 'IT',
	},
	{
		abbreviation: 'JE',
		dialCode: '+44',
		flag: '🇯🇪',
		fullName: 'Jersey',
		label: '🇯🇪 +44',
		value: 'JE',
	},
	{
		abbreviation: 'JM',
		dialCode: '+1876',
		flag: '🇯🇲',
		fullName: 'Jamaica',
		label: '🇯🇲 +1876',
		value: 'JM',
	},
	{
		abbreviation: 'JO',
		dialCode: '+962',
		flag: '🇯🇴',
		fullName: 'Jordan',
		label: '🇯🇴 +962',
		value: 'JO',
	},
	{
		abbreviation: 'JP',
		dialCode: '+81',
		flag: '🇯🇵',
		fullName: 'Japan',
		label: '🇯🇵 +81',
		value: 'JP',
	},
	{
		abbreviation: 'KE',
		dialCode: '+254',
		flag: '🇰🇪',
		fullName: 'Kenya',
		label: '🇰🇪 +254',
		value: 'KE',
	},
	{
		abbreviation: 'KG',
		dialCode: '+996',
		flag: '🇰🇬',
		fullName: 'Kyrgyzstan',
		label: '🇰🇬 +996',
		value: 'KG',
	},
	{
		abbreviation: 'KH',
		dialCode: '+855',
		flag: '🇰🇭',
		fullName: 'Cambodia',
		label: '🇰🇭 +855',
		value: 'KH',
	},
	{
		abbreviation: 'KI',
		dialCode: '+686',
		flag: '🇰🇮',
		fullName: 'Kiribati',
		label: '🇰🇮 +686',
		value: 'KI',
	},
	{
		abbreviation: 'KM',
		dialCode: '+269',
		flag: '🇰🇲',
		fullName: 'Comoros',
		label: '🇰🇲 +269',
		value: 'KM',
	},
	{
		abbreviation: 'KN',
		dialCode: '+1869',
		flag: '🇰🇳',
		fullName: 'Saint Kitts and Nevis',
		label: '🇰🇳 +1869',
		value: 'KN',
	},
	{
		abbreviation: 'KP',
		dialCode: '+850',
		flag: '🇰🇵',
		fullName: "Korea, Democratic People's Republic of Korea",
		label: '🇰🇵 +850',
		value: 'KP',
	},
	{
		abbreviation: 'KR',
		dialCode: '+82',
		flag: '🇰🇷',
		fullName: 'Korea, Republic of South Korea',
		label: '🇰🇷 +82',
		value: 'KR',
	},
	{
		abbreviation: 'KW',
		dialCode: '+965',
		flag: '🇰🇼',
		fullName: 'Kuwait',
		label: '🇰🇼 +965',
		value: 'KW',
	},
	{
		abbreviation: 'KY',
		dialCode: '+345',
		flag: '🇰🇾',
		fullName: 'Cayman Islands',
		label: '🇰🇾 +345',
		value: 'KY',
	},
	{
		abbreviation: 'KZ',
		dialCode: '+7',
		flag: '🇰🇿',
		fullName: 'Kazakhstan',
		label: '🇰🇿 +7',
		value: 'KZ',
	},
	{
		abbreviation: 'LA',
		dialCode: '+856',
		flag: '🇱🇦',
		fullName: 'Laos',
		label: '🇱🇦 +856',
		value: 'LA',
	},
	{
		abbreviation: 'LB',
		dialCode: '+961',
		flag: '🇱🇧',
		fullName: 'Lebanon',
		label: '🇱🇧 +961',
		value: 'LB',
	},
	{
		abbreviation: 'LC',
		dialCode: '+1758',
		flag: '🇱🇨',
		fullName: 'Saint Lucia',
		label: '🇱🇨 +1758',
		value: 'LC',
	},
	{
		abbreviation: 'LI',
		dialCode: '+423',
		flag: '🇱🇮',
		fullName: 'Liechtenstein',
		label: '🇱🇮 +423',
		value: 'LI',
	},
	{
		abbreviation: 'LK',
		dialCode: '+94',
		flag: '🇱🇰',
		fullName: 'Sri Lanka',
		label: '🇱🇰 +94',
		value: 'LK',
	},
	{
		abbreviation: 'LR',
		dialCode: '+231',
		flag: '🇱🇷',
		fullName: 'Liberia',
		label: '🇱🇷 +231',
		value: 'LR',
	},
	{
		abbreviation: 'LS',
		dialCode: '+266',
		flag: '🇱🇸',
		fullName: 'Lesotho',
		label: '🇱🇸 +266',
		value: 'LS',
	},
	{
		abbreviation: 'LT',
		dialCode: '+370',
		flag: '🇱🇹',
		fullName: 'Lithuania',
		label: '🇱🇹 +370',
		value: 'LT',
	},
	{
		abbreviation: 'LU',
		dialCode: '+352',
		flag: '🇱🇺',
		fullName: 'Luxembourg',
		label: '🇱🇺 +352',
		value: 'LU',
	},
	{
		abbreviation: 'LV',
		dialCode: '+371',
		flag: '🇱🇻',
		fullName: 'Latvia',
		label: '🇱🇻 +371',
		value: 'LV',
	},
	{
		abbreviation: 'LY',
		dialCode: '+218',
		flag: '🇱🇾',
		fullName: 'Libyan Arab Jamahiriya',
		label: '🇱🇾 +218',
		value: 'LY',
	},
	{
		abbreviation: 'MA',
		dialCode: '+212',
		flag: '🇲🇦',
		fullName: 'Morocco',
		label: '🇲🇦 +212',
		value: 'MA',
	},
	{
		abbreviation: 'MC',
		dialCode: '+377',
		flag: '🇲🇨',
		fullName: 'Monaco',
		label: '🇲🇨 +377',
		value: 'MC',
	},
	{
		abbreviation: 'MD',
		dialCode: '+373',
		flag: '🇲🇩',
		fullName: 'Moldova',
		label: '🇲🇩 +373',
		value: 'MD',
	},
	{
		abbreviation: 'ME',
		dialCode: '+382',
		flag: '🇲🇪',
		fullName: 'Montenegro',
		label: '🇲🇪 +382',
		value: 'ME',
	},
	{
		abbreviation: 'MF',
		dialCode: '+590',
		flag: '🇲🇫',
		fullName: 'Saint Martin',
		label: '🇲🇫 +590',
		value: 'MF',
	},
	{
		abbreviation: 'MG',
		dialCode: '+261',
		flag: '🇲🇬',
		fullName: 'Madagascar',
		label: '🇲🇬 +261',
		value: 'MG',
	},
	{
		abbreviation: 'MH',
		dialCode: '+692',
		flag: '🇲🇭',
		fullName: 'Marshall Islands',
		label: '🇲🇭 +692',
		value: 'MH',
	},
	{
		abbreviation: 'MK',
		dialCode: '+389',
		flag: '🇲🇰',
		fullName: 'North Macedonia',
		label: '🇲🇰 +389',
		value: 'MK',
	},
	{
		abbreviation: 'ML',
		dialCode: '+223',
		flag: '🇲🇱',
		fullName: 'Mali',
		label: '🇲🇱 +223',
		value: 'ML',
	},
	{
		abbreviation: 'MM',
		dialCode: '+95',
		flag: '🇲🇲',
		fullName: 'Myanmar',
		label: '🇲🇲 +95',
		value: 'MM',
	},
	{
		abbreviation: 'MN',
		dialCode: '+976',
		flag: '🇲🇳',
		fullName: 'Mongolia',
		label: '🇲🇳 +976',
		value: 'MN',
	},
	{
		abbreviation: 'MO',
		dialCode: '+853',
		flag: '🇲🇴',
		fullName: 'Macao',
		label: '🇲🇴 +853',
		value: 'MO',
	},
	{
		abbreviation: 'MP',
		dialCode: '+1670',
		flag: '🇲🇵',
		fullName: 'Northern Mariana Islands',
		label: '🇲🇵 +1670',
		value: 'MP',
	},
	{
		abbreviation: 'MQ',
		dialCode: '+596',
		flag: '🇲🇶',
		fullName: 'Martinique',
		label: '🇲🇶 +596',
		value: 'MQ',
	},
	{
		abbreviation: 'MR',
		dialCode: '+222',
		flag: '🇲🇷',
		fullName: 'Mauritania',
		label: '🇲🇷 +222',
		value: 'MR',
	},
	{
		abbreviation: 'MS',
		dialCode: '+1664',
		flag: '🇲🇸',
		fullName: 'Montserrat',
		label: '🇲🇸 +1664',
		value: 'MS',
	},
	{
		abbreviation: 'MT',
		dialCode: '+356',
		flag: '🇲🇹',
		fullName: 'Malta',
		label: '🇲🇹 +356',
		value: 'MT',
	},
	{
		abbreviation: 'MU',
		dialCode: '+230',
		flag: '🇲🇺',
		fullName: 'Mauritius',
		label: '🇲🇺 +230',
		value: 'MU',
	},
	{
		abbreviation: 'MV',
		dialCode: '+960',
		flag: '🇲🇻',
		fullName: 'Maldives',
		label: '🇲🇻 +960',
		value: 'MV',
	},
	{
		abbreviation: 'MW',
		dialCode: '+265',
		flag: '🇲🇼',
		fullName: 'Malawi',
		label: '🇲🇼 +265',
		value: 'MW',
	},
	{
		abbreviation: 'MX',
		dialCode: '+52',
		flag: '🇲🇽',
		fullName: 'Mexico',
		label: '🇲🇽 +52',
		value: 'MX',
	},
	{
		abbreviation: 'MY',
		dialCode: '+60',
		flag: '🇲🇾',
		fullName: 'Malaysia',
		label: '🇲🇾 +60',
		value: 'MY',
	},
	{
		abbreviation: 'MZ',
		dialCode: '+258',
		flag: '🇲🇿',
		fullName: 'Mozambique',
		label: '🇲🇿 +258',
		value: 'MZ',
	},
	{
		abbreviation: 'NA',
		dialCode: '+264',
		flag: '🇳🇦',
		fullName: 'Namibia',
		label: '🇳🇦 +264',
		value: 'NA',
	},
	{
		abbreviation: 'NC',
		dialCode: '+687',
		flag: '🇳🇨',
		fullName: 'New Caledonia',
		label: '🇳🇨 +687',
		value: 'NC',
	},
	{
		abbreviation: 'NE',
		dialCode: '+227',
		flag: '🇳🇪',
		fullName: 'Niger',
		label: '🇳🇪 +227',
		value: 'NE',
	},
	{
		abbreviation: 'NF',
		dialCode: '+672',
		flag: '🇳🇫',
		fullName: 'Norfolk Island',
		label: '🇳🇫 +672',
		value: 'NF',
	},
	{
		abbreviation: 'NG',
		dialCode: '+234',
		flag: '🇳🇬',
		fullName: 'Nigeria',
		label: '🇳🇬 +234',
		value: 'NG',
	},
	{
		abbreviation: 'NI',
		dialCode: '+505',
		flag: '🇳🇮',
		fullName: 'Nicaragua',
		label: '🇳🇮 +505',
		value: 'NI',
	},
	{
		abbreviation: 'NL',
		dialCode: '+31',
		flag: '🇳🇱',
		fullName: 'Netherlands',
		label: '🇳🇱 +31',
		value: 'NL',
	},
	{
		abbreviation: 'NO',
		dialCode: '+47',
		flag: '🇳🇴',
		fullName: 'Norway',
		label: '🇳🇴 +47',
		value: 'NO',
	},
	{
		abbreviation: 'NP',
		dialCode: '+977',
		flag: '🇳🇵',
		fullName: 'Nepal',
		label: '🇳🇵 +977',
		value: 'NP',
	},
	{
		abbreviation: 'NR',
		dialCode: '+674',
		flag: '🇳🇷',
		fullName: 'Nauru',
		label: '🇳🇷 +674',
		value: 'NR',
	},
	{
		abbreviation: 'NU',
		dialCode: '+683',
		flag: '🇳🇺',
		fullName: 'Niue',
		label: '🇳🇺 +683',
		value: 'NU',
	},
	{
		abbreviation: 'NZ',
		dialCode: '+64',
		flag: '🇳🇿',
		fullName: 'New Zealand',
		label: '🇳🇿 +64',
		value: 'NZ',
	},
	{
		abbreviation: 'OM',
		dialCode: '+968',
		flag: '🇴🇲',
		fullName: 'Oman',
		label: '🇴🇲 +968',
		value: 'OM',
	},
	{
		abbreviation: 'PA',
		dialCode: '+507',
		flag: '🇵🇦',
		fullName: 'Panama',
		label: '🇵🇦 +507',
		value: 'PA',
	},
	{
		abbreviation: 'PE',
		dialCode: '+51',
		flag: '🇵🇪',
		fullName: 'Peru',
		label: '🇵🇪 +51',
		value: 'PE',
	},
	{
		abbreviation: 'PF',
		dialCode: '+689',
		flag: '🇵🇫',
		fullName: 'French Polynesia',
		label: '🇵🇫 +689',
		value: 'PF',
	},
	{
		abbreviation: 'PG',
		dialCode: '+675',
		flag: '🇵🇬',
		fullName: 'Papua New Guinea',
		label: '🇵🇬 +675',
		value: 'PG',
	},
	{
		abbreviation: 'PH',
		dialCode: '+63',
		flag: '🇵🇭',
		fullName: 'Philippines',
		label: '🇵🇭 +63',
		value: 'PH',
	},
	{
		abbreviation: 'PK',
		dialCode: '+92',
		flag: '🇵🇰',
		fullName: 'Pakistan',
		label: '🇵🇰 +92',
		value: 'PK',
	},
	{
		abbreviation: 'PL',
		dialCode: '+48',
		flag: '🇵🇱',
		fullName: 'Poland',
		label: '🇵🇱 +48',
		value: 'PL',
	},
	{
		abbreviation: 'PM',
		dialCode: '+508',
		flag: '🇵🇲',
		fullName: 'Saint Pierre and Miquelon',
		label: '🇵🇲 +508',
		value: 'PM',
	},
	{
		abbreviation: 'PN',
		dialCode: '+64',
		flag: '🇵🇳',
		fullName: 'Pitcairn',
		label: '🇵🇳 +64',
		value: 'PN',
	},
	{
		abbreviation: 'PR',
		dialCode: '+1939',
		flag: '🇵🇷',
		fullName: 'Puerto Rico',
		label: '🇵🇷 +1939',
		value: 'PR',
	},
	{
		abbreviation: 'PS',
		dialCode: '+970',
		flag: '🇵🇸',
		fullName: 'Palestinian Territory, Occupied',
		label: '🇵🇸 +970',
		value: 'PS',
	},
	{
		abbreviation: 'PT',
		dialCode: '+351',
		flag: '🇵🇹',
		fullName: 'Portugal',
		label: '🇵🇹 +351',
		value: 'PT',
	},
	{
		abbreviation: 'PW',
		dialCode: '+680',
		flag: '🇵🇼',
		fullName: 'Palau',
		label: '🇵🇼 +680',
		value: 'PW',
	},
	{
		abbreviation: 'PY',
		dialCode: '+595',
		flag: '🇵🇾',
		fullName: 'Paraguay',
		label: '🇵🇾 +595',
		value: 'PY',
	},
	{
		abbreviation: 'QA',
		dialCode: '+974',
		flag: '🇶🇦',
		fullName: 'Qatar',
		label: '🇶🇦 +974',
		value: 'QA',
	},
	{
		abbreviation: 'RE',
		dialCode: '+262',
		flag: '🇷🇪',
		fullName: 'Reunion',
		label: '🇷🇪 +262',
		value: 'RE',
	},
	{
		abbreviation: 'RO',
		dialCode: '+40',
		flag: '🇷🇴',
		fullName: 'Romania',
		label: '🇷🇴 +40',
		value: 'RO',
	},
	{
		abbreviation: 'RS',
		dialCode: '+381',
		flag: '🇷🇸',
		fullName: 'Serbia',
		label: '🇷🇸 +381',
		value: 'RS',
	},
	{
		abbreviation: 'RU',
		dialCode: '+7',
		flag: '🇷🇺',
		fullName: 'Russia',
		label: '🇷🇺 +7',
		value: 'RU',
	},
	{
		abbreviation: 'RW',
		dialCode: '+250',
		flag: '🇷🇼',
		fullName: 'Rwanda',
		label: '🇷🇼 +250',
		value: 'RW',
	},
	{
		abbreviation: 'SA',
		dialCode: '+966',
		flag: '🇸🇦',
		fullName: 'Saudi Arabia',
		label: '🇸🇦 +966',
		value: 'SA',
	},
	{
		abbreviation: 'SB',
		dialCode: '+677',
		flag: '🇸🇧',
		fullName: 'Solomon Islands',
		label: '🇸🇧 +677',
		value: 'SB',
	},
	{
		abbreviation: 'SC',
		dialCode: '+248',
		flag: '🇸🇨',
		fullName: 'Seychelles',
		label: '🇸🇨 +248',
		value: 'SC',
	},
	{
		abbreviation: 'SD',
		dialCode: '+249',
		flag: '🇸🇩',
		fullName: 'Sudan',
		label: '🇸🇩 +249',
		value: 'SD',
	},
	{
		abbreviation: 'SE',
		dialCode: '+46',
		flag: '🇸🇪',
		fullName: 'Sweden',
		label: '🇸🇪 +46',
		value: 'SE',
	},
	{
		abbreviation: 'SG',
		dialCode: '+65',
		flag: '🇸🇬',
		fullName: 'Singapore',
		label: '🇸🇬 +65',
		value: 'SG',
	},
	{
		abbreviation: 'SH',
		dialCode: '+290',
		flag: '🇸🇭',
		fullName: 'Saint Helena, Ascension and Tristan Da Cunha',
		label: '🇸🇭 +290',
		value: 'SH',
	},
	{
		abbreviation: 'SI',
		dialCode: '+386',
		flag: '🇸🇮',
		fullName: 'Slovenia',
		label: '🇸🇮 +386',
		value: 'SI',
	},
	{
		abbreviation: 'SJ',
		dialCode: '+47',
		flag: '🇸🇯',
		fullName: 'Svalbard and Jan Mayen',
		label: '🇸🇯 +47',
		value: 'SJ',
	},
	{
		abbreviation: 'SK',
		dialCode: '+421',
		flag: '🇸🇰',
		fullName: 'Slovakia',
		label: '🇸🇰 +421',
		value: 'SK',
	},
	{
		abbreviation: 'SL',
		dialCode: '+232',
		flag: '🇸🇱',
		fullName: 'Sierra Leone',
		label: '🇸🇱 +232',
		value: 'SL',
	},
	{
		abbreviation: 'SM',
		dialCode: '+378',
		flag: '🇸🇲',
		fullName: 'San Marino',
		label: '🇸🇲 +378',
		value: 'SM',
	},
	{
		abbreviation: 'SN',
		dialCode: '+221',
		flag: '🇸🇳',
		fullName: 'Senegal',
		label: '🇸🇳 +221',
		value: 'SN',
	},
	{
		abbreviation: 'SO',
		dialCode: '+252',
		flag: '🇸🇴',
		fullName: 'Somalia',
		label: '🇸🇴 +252',
		value: 'SO',
	},
	{
		abbreviation: 'SR',
		dialCode: '+597',
		flag: '🇸🇷',
		fullName: 'Suriname',
		label: '🇸🇷 +597',
		value: 'SR',
	},
	{
		abbreviation: 'SS',
		dialCode: '+211',
		flag: '🇸🇸',
		fullName: 'South Sudan',
		label: '🇸🇸 +211',
		value: 'SS',
	},
	{
		abbreviation: 'ST',
		dialCode: '+239',
		flag: '🇸🇹',
		fullName: 'Sao Tome and Principe',
		label: '🇸🇹 +239',
		value: 'ST',
	},
	{
		abbreviation: 'SV',
		dialCode: '+503',
		flag: '🇸🇻',
		fullName: 'El Salvador',
		label: '🇸🇻 +503',
		value: 'SV',
	},
	{
		abbreviation: 'SY',
		dialCode: '+963',
		flag: '🇸🇾',
		fullName: 'Syrian Arab Republic',
		label: '🇸🇾 +963',
		value: 'SY',
	},
	{
		abbreviation: 'SZ',
		dialCode: '+268',
		flag: '🇸🇿',
		fullName: 'Swaziland',
		label: '🇸🇿 +268',
		value: 'SZ',
	},
	{
		abbreviation: 'TC',
		dialCode: '+1649',
		flag: '🇹🇨',
		fullName: 'Turks and Caicos Islands',
		label: '🇹🇨 +1649',
		value: 'TC',
	},
	{
		abbreviation: 'TD',
		dialCode: '+235',
		flag: '🇹🇩',
		fullName: 'Chad',
		label: '🇹🇩 +235',
		value: 'TD',
	},
	{
		abbreviation: 'TF',
		dialCode: '+262',
		flag: '🇹🇫',
		fullName: 'French Southern Territories',
		label: '🇹🇫 +262',
		value: 'TF',
	},
	{
		abbreviation: 'TG',
		dialCode: '+228',
		flag: '🇹🇬',
		fullName: 'Togo',
		label: '🇹🇬 +228',
		value: 'TG',
	},
	{
		abbreviation: 'TH',
		dialCode: '+66',
		flag: '🇹🇭',
		fullName: 'Thailand',
		label: '🇹🇭 +66',
		value: 'TH',
	},
	{
		abbreviation: 'TJ',
		dialCode: '+992',
		flag: '🇹🇯',
		fullName: 'Tajikistan',
		label: '🇹🇯 +992',
		value: 'TJ',
	},
	{
		abbreviation: 'TK',
		dialCode: '+690',
		flag: '🇹🇰',
		fullName: 'Tokelau',
		label: '🇹🇰 +690',
		value: 'TK',
	},
	{
		abbreviation: 'TL',
		dialCode: '+670',
		flag: '🇹🇱',
		fullName: 'Timor-Leste',
		label: '🇹🇱 +670',
		value: 'TL',
	},
	{
		abbreviation: 'TM',
		dialCode: '+993',
		flag: '🇹🇲',
		fullName: 'Turkmenistan',
		label: '🇹🇲 +993',
		value: 'TM',
	},
	{
		abbreviation: 'TN',
		dialCode: '+216',
		flag: '🇹🇳',
		fullName: 'Tunisia',
		label: '🇹🇳 +216',
		value: 'TN',
	},
	{
		abbreviation: 'TO',
		dialCode: '+676',
		flag: '🇹🇴',
		fullName: 'Tonga',
		label: '🇹🇴 +676',
		value: 'TO',
	},
	{
		abbreviation: 'TR',
		dialCode: '+90',
		flag: '🇹🇷',
		fullName: 'Türkiye',
		label: '🇹🇷 +90',
		value: 'TR',
	},
	{
		abbreviation: 'TT',
		dialCode: '+1868',
		flag: '🇹🇹',
		fullName: 'Trinidad and Tobago',
		label: '🇹🇹 +1868',
		value: 'TT',
	},
	{
		abbreviation: 'TV',
		dialCode: '+688',
		flag: '🇹🇻',
		fullName: 'Tuvalu',
		label: '🇹🇻 +688',
		value: 'TV',
	},
	{
		abbreviation: 'TW',
		dialCode: '+886',
		flag: '🇹🇼',
		fullName: 'Taiwan',
		label: '🇹🇼 +886',
		value: 'TW',
	},
	{
		abbreviation: 'TZ',
		dialCode: '+255',
		flag: '🇹🇿',
		fullName: 'Tanzania, United Republic of Tanzania',
		label: '🇹🇿 +255',
		value: 'TZ',
	},
	{
		abbreviation: 'UA',
		dialCode: '+380',
		flag: '🇺🇦',
		fullName: 'Ukraine',
		label: '🇺🇦 +380',
		value: 'UA',
	},
	{
		abbreviation: 'UG',
		dialCode: '+256',
		flag: '🇺🇬',
		fullName: 'Uganda',
		label: '🇺🇬 +256',
		value: 'UG',
	},
	{
		abbreviation: 'US',
		dialCode: '+1',
		flag: '🇺🇸',
		fullName: 'United States',
		label: '🇺🇸 +1',
		value: 'US',
	},
	{
		abbreviation: 'UY',
		dialCode: '+598',
		flag: '🇺🇾',
		fullName: 'Uruguay',
		label: '🇺🇾 +598',
		value: 'UY',
	},
	{
		abbreviation: 'UZ',
		dialCode: '+998',
		flag: '🇺🇿',
		fullName: 'Uzbekistan',
		label: '🇺🇿 +998',
		value: 'UZ',
	},
	{
		abbreviation: 'VA',
		dialCode: '+379',
		flag: '🇻🇦',
		fullName: 'Holy See (Vatican City State)',
		label: '🇻🇦 +379',
		value: 'VA',
	},
	{
		abbreviation: 'VC',
		dialCode: '+1784',
		flag: '🇻🇨',
		fullName: 'Saint Vincent and the Grenadines',
		label: '🇻🇨 +1784',
		value: 'VC',
	},
	{
		abbreviation: 'VE',
		dialCode: '+58',
		flag: '🇻🇪',
		fullName: 'Venezuela, Bolivarian Republic of Venezuela',
		label: '🇻🇪 +58',
		value: 'VE',
	},
	{
		abbreviation: 'VG',
		dialCode: '+1284',
		flag: '🇻🇬',
		fullName: 'Virgin Islands, British',
		label: '🇻🇬 +1284',
		value: 'VG',
	},
	{
		abbreviation: 'VI',
		dialCode: '+1340',
		flag: '🇻🇮',
		fullName: 'Virgin Islands, U.S.',
		label: '🇻🇮 +1340',
		value: 'VI',
	},
	{
		abbreviation: 'VN',
		dialCode: '+84',
		flag: '🇻🇳',
		fullName: 'Vietnam',
		label: '🇻🇳 +84',
		value: 'VN',
	},
	{
		abbreviation: 'VU',
		dialCode: '+678',
		flag: '🇻🇺',
		fullName: 'Vanuatu',
		label: '🇻🇺 +678',
		value: 'VU',
	},
	{
		abbreviation: 'WF',
		dialCode: '+681',
		flag: '🇼🇫',
		fullName: 'Wallis and Futuna',
		label: '🇼🇫 +681',
		value: 'WF',
	},
	{
		abbreviation: 'WS',
		dialCode: '+685',
		flag: '🇼🇸',
		fullName: 'Samoa',
		label: '🇼🇸 +685',
		value: 'WS',
	},
	{
		abbreviation: 'XK',
		dialCode: '+383',
		flag: '🇽🇰',
		fullName: 'Kosovo',
		label: '🇽🇰 +383',
		value: 'XK',
	},
	{
		abbreviation: 'YE',
		dialCode: '+967',
		flag: '🇾🇪',
		fullName: 'Yemen',
		label: '🇾🇪 +967',
		value: 'YE',
	},
	{
		abbreviation: 'YT',
		dialCode: '+262',
		flag: '🇾🇹',
		fullName: 'Mayotte',
		label: '🇾🇹 +262',
		value: 'YT',
	},
	{
		abbreviation: 'ZA',
		dialCode: '+27',
		flag: '🇿🇦',
		fullName: 'South Africa',
		label: '🇿🇦 +27',
		value: 'ZA',
	},
	{
		abbreviation: 'ZM',
		dialCode: '+260',
		flag: '🇿🇲',
		fullName: 'Zambia',
		label: '🇿🇲 +260',
		value: 'ZM',
	},
	{
		abbreviation: 'ZW',
		dialCode: '+263',
		flag: '🇿🇼',
		fullName: 'Zimbabwe',
		label: '🇿🇼 +263',
		value: 'ZW',
	},
];
